/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { AGENCY_ADMINISTRATION } from 'dxpAdministration-mf/Constants';
import { CONSOLE_CORE } from 'dxpConsoleCore-mf/Constants';
import { DXP_CAPABILITIES } from '../../Constants/DxpCapabilities.constants';
import { DxpCapability } from '../../Constants/DxpCapabilities/defs/DxpCapability.defs';
import { isAgency } from '../../Utilities/IsAgency/IsAgency';
import { isOrganisation } from '../../Utilities/IsOrganisation/IsOrganisation';

/**
 * Get the current DXP capability.
 * @export
 * @returns {string} The current DXP capability.
 */
export const getCapability = (): DxpCapability => {
  const { pathname } = location;
  const locationItems = pathname.split(`/`).filter((part) => part !== ``);

  if (isAgency()) {
    // Load the agency administration capability
    return AGENCY_ADMINISTRATION;
  } else if (isOrganisation()) {
    // Load the specific organisation capability
    return DXP_CAPABILITIES.filter((item: DxpCapability) => item?.prefix === locationItems[2])[0] || CONSOLE_CORE;
  } else {
    // Load the core capability
    return CONSOLE_CORE;
  }
};
